module.exports = __webpack_public_path__ + "assets/LDropPerp2Detailed.e092bcec3966d036dd4d8d27484e2791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/LDropPerp2Detailed.png
// module id = 530
// module chunks = 0